










import { defineComponent, ref, computed, watch } from '@vue/composition-api';

export default defineComponent({
  name: 'AddSubtractNum',
  components: {
  },
  props: {
    minNum: {
      type: Number,
      default: 1,
    },
    maxNum: {
      type: Number,
      default: 7,
    },
    currentNum: {
      type: Number,
      default: 1,
    },
    numRightText: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const showCurrentNum = ref(props.currentNum);
    const subtractClass = computed(() => ((showCurrentNum.value <= props.minNum) ? 'disabled' : ''));
    const addClass = computed(() => ((showCurrentNum.value >= props.maxNum) ? 'disabled' : ''));
    const changeNum = function (num) {
      showCurrentNum.value = num;
      emit('numChange', showCurrentNum.value);
    };
    watch(props, () => {
      showCurrentNum.value = props.currentNum;
      emit('numChange', showCurrentNum.value);
    });
    return {
      showCurrentNum,
      subtractClass,
      addClass,
      setCurrentNum(num) {
        changeNum(num);
      },
      subtract() {
        if (showCurrentNum.value <= props.minNum) {
          return;
        }
        changeNum(showCurrentNum.value - 1);
      },
      add() {
        if (showCurrentNum.value >= props.maxNum) {
          return;
        }
        changeNum(showCurrentNum.value + 1);
      },
    };
  },
});
